module.exports = __webpack_public_path__ + "img/top_add.0a393ab7.jpg";